<template>
  <div class="app-wrapper">
    <!--侧边栏-->
    <SideBar class="sidebar-container"></SideBar>
    <div class="main-contain">
      <!--顶部导航栏-->
      <div class="fixed-header">
        <NavBar/>
      </div>
      <!--正文部分-->
      <div class="app-main">
        <!--主体-->
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view :key="$route.fullPath"/>
          </keep-alive>
        </transition>
        <!--页脚-->
        <div id="admin-footer">
          <span>哈尔滨新中新电子股份有限公司 版权所有 ◎ 2019</span>
          <span> ⋅ </span>
          <a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank">黑ICP备08101720号-2</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/layout/components/SideBar'
import NavBar from '@/layout/components/NavBar'

export default {
  name: 'AdminMain',
  components: { NavBar, SideBar },
  computed: {
    key () {
      return this.$route.fullPath
    }
  },
  methods: {}
}
</script>

<style lang="scss">
  /*侧边栏样式*/
  .sidebar-container {
    transition: width 0.28s;
    width: 180px !important;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
    //reset element-ui css
    .horizontal-collapse-transition {
      transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
    }

    .el-scrollbar__bar.is-vertical {
      right: 0;
    }

    .scrollbar-wrapper {
      overflow-x: hidden !important;

      .el-scrollbar__view {
        height: 100%;
      }
    }

    .is-horizontal {
      display: none;
    }

    a {
      display: inline-block;
      width: 100%;
      overflow: hidden;
    }

    .svg-icon {
      margin-right: 16px;
    }

    .el-menu {
      border: none;
      height: 100%;
      width: 100% !important;
    }

    .is-active > .el-submenu__title {
      color: #f4f4f5 !important;
    }
  }

  .main-contain {
    padding-left: 180px;
    min-height: 100%;
    position: relative;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    width: calc(100% - 180px);
    background: #ffffff;
    z-index: 99;
    transition: width 0.28s;
  }

  .app-main {
    z-index: 88;
    min-height: calc(100vh - 60px);
    width: 100%;
    padding-top: 60px;
    position: relative;
    overflow: hidden;
  }

  #admin-footer {
    background: none repeat scroll 0 0 white;
    border-top: 1px solid #e7eaec;
    overflow: hidden;
    padding: 10px 6px 0 6px;
    height: 33px;
    font-size: 0.7rem !important;
    color: #7a8b9a;
    letter-spacing: 0.8px;
    font-family: Arial, sans-serif !important;
    position: fixed;
    bottom: 0;
    z-index: 99;
    width: 100%;
  }
</style>
